import { ApplifecycleEffects } from './applifecycle.effects';
import { AuthEffects } from './auth.effects';
import { DataModelEffects } from './datamodel.effects';
import { RoleEffects } from './roles.effects';
import { ServiceEffects } from './services.effects';
import { MenuEffects } from './menu.effects';
import { PropertyPaneEffects } from './propertypane.effects';
import { ScreensEffects } from './screens.effects';
import { DocumentsEffects } from './documents.effects';
import { FileAttachmentsEffects } from './fileattachments.effects';
import { OrgManagementEffects } from './orgmanagement.effects';
import { UsersEffects } from './users.effects';
import { UserStoriesEffects } from './userstories.effects';
import { TechnologyStackEffects } from './technologystack.effects';
import { SampleDataEffects } from './sampleData.effects';
import { TemplatesEffects } from './templates.effects';
import { TranslationEffects } from './translation.effects';
import { CustomComponentEffects } from './customcomponent.effects';
import { AppConfigKeysEffects } from './appconfigkeys.effects';
import { TableAclEffects } from './tableacl.effects';
import { CodeGenEffects } from './codegeneration.effects';
import { WorkFlowEffects } from './workflow.effects';
import { LoginMethodEffects } from './loginmethod.effects';
import { QueryBuilderEffects } from './queryBuilder.effects';
import { IndexDesignerEffects } from './indexdesigner.effects';
import { MailInfoEffects } from './mailInfo.effects';
import { AppDataModelEffects } from './applicationdatamodel.effects';
import { GlobalServiceEffects } from './globalservice.effects';
import { ExposedrestEffects } from './exposedrest.effects';
import { ConsumedrestEffects } from './consumedrest.effects';
import { AiAppDataModelEffects } from './aiapplicationdatamodel.effects';
import { GenerationsEffects } from './generations/generation.effects';
import { ModuleEffects } from './generations/module.effects';
import { RoleInterimEffects } from './generations/role.effects';
import { ScreenInterimEffects } from './generations/screen-interim.effects';
import { ProcessEffects } from './generations/process.effects';
import { GenerationUserStoriesEffects } from './generations/userstory.effects';
import { WizardCompletionEffects } from './generations/summary.effects';
import { InputEffects } from './generations/input.effects';
import { WizardStepEffects } from './generations/generation-step.effects';
import { AIDataModelGenerationEffects } from './generations/ai-datamodel.effects';
import { UserStoriesV2Effects } from './userstoriesv2.effects';
import { LookupDefinitionsEffects } from './lookupdefinitions.effects';
import { QueryStringEffects } from './querystring.effects';
import { IngestionAnalysisEffects } from './generations/doc-analysis.effects';
import { EffectsModule } from '@ngrx/effects';
import { AclpermissionEffects } from './generations/aclpermission.effects';
export const effects = [
  AuthEffects,
  MenuEffects,
  PropertyPaneEffects,
  DataModelEffects,
  ApplifecycleEffects,
  RoleEffects,
  ServiceEffects,
  ScreensEffects,
  DocumentsEffects,
  FileAttachmentsEffects,
  OrgManagementEffects,
  UsersEffects,
  UserStoriesEffects,
  TechnologyStackEffects,
  SampleDataEffects,
  TemplatesEffects,
  TranslationEffects,
  CustomComponentEffects,
  AppConfigKeysEffects,
  TableAclEffects,
  CodeGenEffects,
  LoginMethodEffects,
  WorkFlowEffects,
  QueryBuilderEffects,
  IndexDesignerEffects,
  MailInfoEffects,
  AppDataModelEffects,
  GlobalServiceEffects,
  ExposedrestEffects,
  ConsumedrestEffects,
  AiAppDataModelEffects,
  LookupDefinitionsEffects,
  QueryStringEffects,
  GenerationsEffects,
  ModuleEffects,
  RoleInterimEffects,
  ScreenInterimEffects,
  ProcessEffects,
  GenerationUserStoriesEffects,
  WizardCompletionEffects,
  InputEffects,
  WizardStepEffects,
  AIDataModelGenerationEffects,
  UserStoriesV2Effects,
  IngestionAnalysisEffects,
  AclpermissionEffects
];
